export class Counter {
    public title!: string
    public counterPostfix!: string
    public count: Number = 0
    public current: Number = 0

    constructor() { }
}

export class CounterWidget {
    public title!: string
    public counters: Counter[] = [];

    constructor() { }
}
